import MemberProfilePage from 'pages/MemberProfilePage';
import MembersPage from 'pages/MembersPage';

const routes = {
  public: [],
  private: [
    {
      path: '/member/:userEmail',
      component: <MemberProfilePage />,
    },
    {
      path: '/members',
      component: <MembersPage />,
    },
  ],
};

export default routes;
